// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__ea-7M","col":"styles_col__3JHEU","actions":"styles_actions__2-Ij3","conflict":"styles_conflict__1xszL"};